export function usingInternetExplorer() {
	return !!(<any>document).documentMode;
}
